import { motion } from 'framer-motion';
import { menuCategories } from '../data/menuData';
import { MenuItemCard } from '../components/MenuItemCard';

export default function Menu() {
  return (
    <div className="min-h-screen py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold text-brown-dark mb-4">
            Our Menu
          </h1>
          <p className="text-lg text-brown-medium max-w-2xl mx-auto">
            Explore our gourmet chaat collection and refreshing coolers
          </p>
        </motion.div>

        {menuCategories.map((category, catIndex) => (
          <section key={category.id} className="mb-16" data-testid={`menu-category-${category.id}`}>
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="mb-8"
            >
              <h2 className="text-3xl sm:text-4xl font-playfair font-bold text-spice mb-2">
                {category.name}
              </h2>
              <p className="text-brown-medium text-lg">{category.description}</p>
            </motion.div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {category.items.map((item, index) => (
                <MenuItemCard key={item.id} item={item} index={index} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}